import { Component, OnInit, Input, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../..../../../store/state/app.state';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    imports: [ReactiveFormsModule, NgClass]
})
export class ButtonComponent implements OnInit, AfterContentChecked {
  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() isDisabled;
  @Input() buttonType;
  @Input() isloading: boolean = false;

  protected contentData: object;
  protected cmsProductChoice: object;
  protected playbackList = [];
  public cmsDataProductChoice: any;
  public productsChoice: any;
  protected selectedProduct: any;
  public selectedProductCode: string;
  public productsChoiceStore: Observable<any[]>;
  doneBtnFlag: boolean = false;

  constructor(private fb: UntypedFormBuilder, public router: Router, private route: ActivatedRoute, 
    private store: Store<AppState>, private cdRef :ChangeDetectorRef) { 


    this.contentData = this.route.snapshot.data.contentData;
    this.cmsProductChoice = this.route.snapshot.data.contentData.pleaseConfirmDetails;
    this.playbackList = this.route.snapshot.data.contentData.pleaseConfirmDetails.playBack;
    this.cmsDataProductChoice = this.route.snapshot.data.contentData.productChoice;

    this.productsChoiceStore = store.select(STORE_VAL.quote_capture);
    this.productsChoiceStore.subscribe(res => {
      if (res.length > 0) {
        this.productsChoice = res[0];
      }
    });
  }

  ngOnInit() {
    if (this.productsChoice && this.productsChoice.product) {
      this.selectedProduct = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productName;
      this.selectedProductCode = this.cmsDataProductChoice.products.find(p => p.productCode === this.productsChoice['product']).productCode;
    }
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }

  getID(idValue) {
    let s;
    s = idValue ? idValue.replace(/\s/g, '') : 'button';
    this.doneBtnFlag = (s && s.indexOf('DoneEditing') > -1 ? true : false);
    return s;
  }
}
